import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class IsolateEndpointActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = true;
  protected canRunForMultipleItems = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    return ProtectedEntitiesHelper.isUnifiedClient(record);
  }
}
